import { useState } from 'react'
import { Formik, Form } from 'formik'
import { StyleAppointmentWrapper, StyleProfileWrapper, StyleRow } from './style'
import PatientProfileForm from './patientProfileForm'
import AppointmentForm from './appointmentForm'
import { Helper } from '@utils'
import { Appointment } from '@apis'
import { AppointmentSchema } from '@validations'
const AppointmentFormPage = () => {
  const shift = Helper.getTimeOfDay()
  const [initialValues, setInitialValues] = useState({
    createdBy: null,
    userId: null,
    appointmentType: '',
    date: '',
    time: '',
    reports: [],
    infos: {
      shift: shift,
    },
    symptoms: [],
    patient: {},
  })
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    setLoading(true)
    const date = `${values?.date} ${values?.time?.split('-')[0]}:00`
    const payload: any = {
      type: 'Consult',
      userId: values?.userId,
      infos: values?.infos,
      createdBy: values?.createdBy,
      date,
    }
    if (values?.symptoms?.length) {
      payload.symptoms = values?.symptoms
    }
    if (values?.reports?.length) {
      payload.reports = values?.reports?.map((report) => {
        return {
          base64: report?.base64,
          extension: report?.extension,
        }
      })
    }
    await Appointment.create({
      data: payload,
      state: 'consultAppointments',
      action: 'update',
    }).catch(() => {})
    setLoading(false)
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      validationSchema={
        AppointmentSchema.institutionCreateAppointmentValidationSchema
      }
    >
      {({ handleSubmit, setFieldValue, values, errors }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <StyleRow>
              <StyleProfileWrapper>
                <PatientProfileForm
                  setFieldValue={setFieldValue}
                  values={values}
                  error={errors?.createdBy}
                />
              </StyleProfileWrapper>
              <StyleAppointmentWrapper>
                <AppointmentForm
                  setFieldValue={setFieldValue}
                  values={values}
                  loading={loading}
                />
              </StyleAppointmentWrapper>
            </StyleRow>
          </Form>
        )
      }}
    </Formik>
  )
}

export default AppointmentFormPage
